import img1 from "./Assets/Images/01.webp";
import img2 from "./Assets/Images/02.webp";
import img3 from "./Assets/Images/03.webp";
import img4 from "./Assets/Images/04.webp";
import img5 from "./Assets/Images/05.webp";
import img6 from "./Assets/Images/06.webp";
import img7 from "./Assets/Images/07.webp";
import img8 from "./Assets/Images/08.webp";
import img9 from "./Assets/Images/09.webp";
import img10 from "./Assets/Images/10.webp";
import img11 from "./Assets/Images/11.webp";
import img12 from "./Assets/Images/12.webp";

export const UtilityData = [
  { id: 1, img: img1, span1: "Premium level", span2: "membership access" },
  { id: 2, img: img2, span1: "Whitelist access", span2: "to RA Crocs" },
  {
    id: 3,
    img: img3,
    span1: "One free parcel of land",
    span2: "per OG Croc held",
  },
  {
    id: 4,
    img: img4,
    span1: "Highest Daily $C4",
    span2: "Token Staking Rewards",
  },
  {
    id: 5,
    img: img5,
    span1: "Access to the Croc",
    span2: "Arcade, Play to Earn Games",
  },
  { id: 6, img: img6, span1: "$C4 Store", span2: "" },
  { id: 7, img: img7, span1: "Metaverse", span2: "" },
  { id: 8, img: img8, span1: "Croc Breeding Game", span2: "" },
  { id: 9, img: img9, span1: "Ability to breed", span2: "Baby Crocs" },
  { id: 10, img: img10, span1: "Gaming Incubator", span2: "" },
  { id: 11, img: img11, span1: "OG Croc only", span2: "merch drops" },
  { id: 12, img: img12, span1: "Voting on Croc", span2: "Community Chest" },
];
